export default __webpack_public_path__ + "static/media/background-1.5294c6da.png";